const LISTRAK_STORAGE_KEY = 'ltk_accepts_cookies';

function saveToLocalStorage(value) {
  try {
    localStorage.setItem(LISTRAK_STORAGE_KEY, JSON.stringify(value));
  } catch (error) {
    console.warn(error);
  }
}

function getFromLocalStorage() {
  try {
    return JSON.parse(localStorage.getItem(LISTRAK_STORAGE_KEY));
  } catch (error) {
    console.warn(error);
    return null;
  }
}

// Consent-driven Listrak loading.
// C0003 is the cookie category for "Functionality" in OneTrust
// C0004 is the cookie category for "Targeting" in OneTrust
// Ref: https://my.onetrust.com/s/article/UUID-8102e851-d860-d465-d8d6-b1d636d68eb9?language=en_US

// Read the category from the blocker's own vendor map so the two can never disagree 
// — loading the SDK on a category the blocker denies injects a script guaranteed to fail. 
// Falls back to C0003 on stores without gating (NS, JJ).
function listrakCategory() {
  if (window.RSConsent && window.RSConsent.vendors) {
    const rule = window.RSConsent.vendors.filter((v) =>
      v.match.test('cdn.listrakbi.com')
    )[0];
    if (rule) return rule.category;
  }
  return 'C0003';
}

function applyListrakConsent(consent) {
  const ltkCookieValue = consent.has('C0004');

  saveToLocalStorage(ltkCookieValue);
  const listrakBISForm = document.querySelector('bis-form-wrapper');
  const listrakWaitlistForm = document.querySelector('listrak-waitlist-form');

  if (consent.has(listrakCategory())) {
    const technicalDataEl = document.querySelector('[data-technical]');
    if (!technicalDataEl) return;
    const data = JSON.parse(technicalDataEl.textContent);
    const listrakID = data['listrakId'] ?? null;
    loadListrak(ltkCookieValue, listrakID);

    if (listrakBISForm) {
      listrakBISForm.style.display = 'block';
    }
    if (listrakWaitlistForm) {
      listrakWaitlistForm.style.display = 'block';
    }
  } else {
    if (listrakBISForm) {
      listrakBISForm.style.display = 'none';
    }
    if (listrakWaitlistForm) {
      listrakWaitlistForm.style.display = 'none';
    }
  }
}

// The single OptanonWrapper lives in snippets/rs-consent-gating.liquid; 
// this registers with it rather than declaring a second one.
if (window.PTRConsent) {
  window.PTRConsent.onChange(applyListrakConsent);
} else {
  window.OptanonWrapper = function () {
    applyListrakConsent({
      has: function (cat) {
        return (window.OnetrustActiveGroups || '').includes(cat);
      },
    });
  };
}

function loadListrak(value, listrakID) {
  if (!listrakID || listrakID == '' || value == undefined) return;
  var biJsHost = 'https:' == document.location.protocol ? 'https://' : 'http://';
  (function (d, s, id, tid, vid) {
    var js,
      ljs = d.getElementsByTagName(s)[0];
    var existing = d.getElementById(id);
    if (existing) {
      var live = existing.getAttribute('src') && !/text\/plain/i.test(existing.type || '');
      if (live) return;
      existing.parentNode && existing.parentNode.removeChild(existing);
    }
    js = d.createElement(s);
    js.id = id;

    if (window.PTRConsent) js.setAttribute('data-ot-ignore', '');

    js.src = biJsHost + 'cdn.listrakbi.com/scripts/script.js?m=' + tid + '&v=' + vid;
    ljs.parentNode.insertBefore(js, ljs);
  })(document, 'script', 'ltkSDK', listrakID, '1');

  setPersonalizedStatus(value, 10);
}

// The SDK may never arrive — consent, ad blocker, network. 
// Poll for it rather than assuming it exists after a fixed delay, then give up quietly.
function setPersonalizedStatus(value, attemptsLeft) {
  if (window._ltk && _ltk.Session && typeof _ltk.Session.setPersonalizedStatus === 'function') {
    _ltk.Session.setPersonalizedStatus(value);
    return;
  }
  if (attemptsLeft > 0) {
    setTimeout(function () {
      setPersonalizedStatus(value, attemptsLeft - 1);
    }, 1000);
  }
}
